module.exports = __webpack_public_path__ + "848afea62f8558de0b4d52cf59083310.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/clearance.svg
// module id = 89
// module chunks = 0